
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsArticleSeasonDialog extends Serenity.EntityDialog<CsArticleSeasonRow, any> {
        protected getFormKey() { return CsArticleSeasonForm.formKey; }
        protected getIdProperty() { return CsArticleSeasonRow.idProperty; }
        protected getLocalTextPrefix() { return CsArticleSeasonRow.localTextPrefix; }
        protected getNameProperty() { return CsArticleSeasonRow.nameProperty; }
        protected getService() { return CsArticleSeasonService.baseUrl; }
        protected getDeletePermission() { return CsArticleSeasonRow.deletePermission; }
        protected getInsertPermission() { return CsArticleSeasonRow.insertPermission; }
        protected getUpdatePermission() { return CsArticleSeasonRow.updatePermission; }

        protected form = new CsArticleSeasonForm(this.idPrefix);

    }
}